import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	ItemImageContainer,
	Image
} from './shopBagItemStyles';

const ItemImage = ({ href, image }) => {
	return (
		<ItemImageContainer>
			<a href={href}>
				<Image src={image} />
			</a>
		</ItemImageContainer>
	);
};

ItemImage.propTypes = {
	href: PropTypes.string.isRequired,
	image: PropTypes.string.isRequired,
};

export default ItemImage;
